import { render, staticRenderFns } from "./ExportProfiles.vue?vue&type=template&id=58b31c1b&scoped=true&"
import script from "./ExportProfiles.vue?vue&type=script&lang=js&"
export * from "./ExportProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b31c1b",
  null
  
)

export default component.exports